import { ProviderUserType } from "../../../enums";

export class ProviderUserUpdateRequest {
  type: ProviderUserType;
}
